import { LearningLifecyclesData } from '@src/graphql/home/queries';

/**
 * Takes an array of Learning Lifecycles and generates an options array
 * of applications grouped by academic partner, to be used in the Recess
 * `Select` component.
 *
 * @packageDocumentation
 */

export const createLifecycleSelectOptions = (learningLifecycles: LearningLifecyclesData[]) => {
  const options = learningLifecycles.reduce((acc, lifecycle) => {
    const academicPartner = lifecycle?.program?.studentFacingAcademicPartner;
    const uuid = academicPartner?.uuid;

    if (!uuid || !lifecycle.program) return acc;

    if (!acc[uuid]) {
      acc[uuid] = {
        label: academicPartner?.name || '',
        options: [],
      };
    }

    const option = {
      label: lifecycle.program.name,
      value: lifecycle.applicationId,
    };

    acc[uuid].options.push(option);
    return acc;
  }, []);

  return Object.values(options);
};
